// // RentDescriptionCard.js
// import React, { useState, useEffect } from "react";
// import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
// import { BASE_URL } from "../../Api/ApiUrls";

// // ─── Helper: Haversine distance (km) ────────────────────────────────────────
// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const R = 6371;
//   const dLat = ((lat2 - lat1) * Math.PI) / 180;
//   const dLon = ((lon2 - lon1) * Math.PI) / 180;
//   const a =
//     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//     Math.cos((lat1 * Math.PI) / 180) *
//       Math.cos((lat2 * Math.PI) / 180) *
//       Math.sin(dLon / 2) *
//       Math.sin(dLon / 2);
//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// // ─── Helper: read user location from localStorage ───────────────────────────
// const getUserLocation = () => {
//   const lat = localStorage.getItem("userLatitude");
//   const lng = localStorage.getItem("userLongitude");
//   const address = localStorage.getItem("userLocation");

//   if (lat && lng) {
//     return {
//       latitude: parseFloat(lat),
//       longitude: parseFloat(lng),
//       address: address || "Current Location",
//     };
//   }
//   return null;
// };

// // ─── Helper: check if displaying_pannels contains "rent_description" ────────
// const matchesRentDescription = (displayingPannels) => {
//   if (!displayingPannels) return false;

//   let values = [];

//   if (Array.isArray(displayingPannels)) {
//     values = displayingPannels.map((v) =>
//       typeof v === "string" ? v : v?.name || v?.value || String(v),
//     );
//   } else if (typeof displayingPannels === "string") {
//     values = displayingPannels.split(",").map((s) => s.trim());
//   } else if (typeof displayingPannels === "object") {
//     values = Object.values(displayingPannels).map(String);
//   } else {
//     values = [String(displayingPannels)];
//   }

//   return values.some((v) => String(v).toLowerCase() === "rent_description");
// };

// // ─── Component ──────────────────────────────────────────────────────────────
// const RentDescriptionCard = () => {
//   const [allProperties, setAllProperties] = useState([]);
//   const [filteredProperties, setFilteredProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userLocation, setUserLocation] = useState(null);
//   const [locationLoading, setLocationLoading] = useState(true);

//   // Get user location on mount
//   useEffect(() => {
//     const location = getUserLocation();
//     setUserLocation(location);
//     setLocationLoading(false);
//   }, []);

//   // ─── Location-based filtering ─────────────────────────────────────────────
//   //   const filterPropertiesByLocation = (properties, location) => {
//   //     if (!location) {
//   //       setFilteredProperties([]);
//   //       return;
//   //     }

//   //     console.log("User Location:", location);
//   //     console.log("Total Properties (after buy_description filter):", properties.length);

//   //     const filtered = properties.filter((property) => {
//   //       if (!property.lat || !property.long) {
//   //         console.log(
//   //           `Property ${property.id} (${property.title}) has no coordinates - SKIPPING`
//   //         );
//   //         return false;
//   //       }

//   //       const distance = calculateDistance(
//   //         location.latitude,
//   //         location.longitude,
//   //         property.lat,
//   //         property.long
//   //       );

//   //       const radiusDistance = property.radius_distance || 10;
//   //       const isWithinRadius = distance <= radiusDistance;

//   //       property._distance = distance;
//   //       property._radius = radiusDistance;
//   //       property._isWithinRadius = isWithinRadius;

//   //       if (isWithinRadius) {
//   //         console.log(
//   //           `✅ ${property.title}: ${distance.toFixed(2)}km <= ${radiusDistance}km - SHOWING`
//   //         );
//   //       } else {
//   //         console.log(
//   //           `❌ ${property.title}: ${distance.toFixed(2)}km > ${radiusDistance}km - HIDING`
//   //         );
//   //       }

//   //       return isWithinRadius;
//   //     });

//   //     filtered.sort((a, b) => (a._distance || 0) - (b._distance || 0));
//   //     console.log(`Filtered Properties: ${filtered.length} found`);
//   //     setFilteredProperties(filtered);
//   //   };

//   const filterPropertiesByLocation = (properties, location) => {
//     // 🔕 Location-based filtering temporarily disabled.
//     // Distance is still calculated (if location is available) so the
//     // "X km away" text keeps working, but no items are hidden.

//     const result = properties.map((property) => {
//       if (location && property.lat && property.long) {
//         const distance = calculateDistance(
//           location.latitude,
//           location.longitude,
//           property.lat,
//           property.long,
//         );
//         property._distance = distance;
//         property._radius = property.radius_distance || 10;
//         property._isWithinRadius = true; // treat all as visible
//       } else {
//         property._distance = null;
//         property._radius = null;
//         property._isWithinRadius = true;
//       }
//       return property;
//     });

//     // Optional: sort by distance when location is available
//     if (location) {
//       result.sort((a, b) => (a._distance || 0) - (b._distance || 0));
//     }

//     console.log(
//       `[location-filter disabled] Showing all ${result.length} properties`,
//     );
//     setFilteredProperties(result);
//   };

//   // ─── Fetch + filter by rent_description ───────────────────────────────────
//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const url = `${BASE_URL}/ad-properties/performance/?displaying_pannels=rent_description&status=true`;
//         console.log("[RentDescriptionCard] Fetching:", url);

//         const response = await fetch(url);
//         const data = await response.json();

//         let rawList = [];
//         if (Array.isArray(data)) {
//           rawList = data;
//         } else if (Array.isArray(data?.data)) {
//           rawList = data.data;
//         } else if (data?.data && typeof data.data === "object") {
//           rawList = [data.data];
//         } else if (Array.isArray(data?.results)) {
//           rawList = data.results;
//         }

//         console.log(
//           "[RentDescriptionCard] API response items:",
//           rawList.length,
//           "| sample:",
//           rawList[0],
//         );

//         const descriptionFiltered = rawList.filter((item) =>
//           matchesRentDescription(item.displaying_pannels),
//         );

//         console.log(
//           `[RentDescriptionCard] After rent_description filter:`,
//           descriptionFiltered.length,
//           "items",
//         );

//         const propertyData = descriptionFiltered.map((item) => {
//           let lat = null;
//           let long = null;
//           let radiusDistance = null;

//           if (item.lat && item.long) {
//             lat = parseFloat(item.lat);
//             long = parseFloat(item.long);
//           }
//           if (item.radius_distance) {
//             radiusDistance = parseFloat(item.radius_distance);
//           }

//           const heroImg = item.hero_images?.[0]?.image || item.image || null;

//           return {
//             id: item.property_id ?? item.id,
//             type: item.property_type || "Premium",
//             title: item.property_name || "Property",
//             subtitle: item.property_type || "Premium Apartments",
//             price: item.price
//               ? `₹${Number(item.price).toLocaleString("en-IN")}`
//               : item.max_budget
//                 ? `₹${Number(item.max_budget).toLocaleString("en-IN")}`
//                 : "₹3.25 Cr",
//             location: item.address || item.city || "Location not specified",
//             image: heroImg,
//             category: item.category_name || "",
//             tags: item.tags || "",
//             description: item.description || "",
//             lat,
//             long,
//             radius_distance: radiusDistance,
//             displaying_pannels: item.displaying_pannels,
//             _distance: null,
//             _radius: null,
//             _isWithinRadius: false,
//           };
//         });

//         setAllProperties(propertyData);

//         if (userLocation) {
//           filterPropertiesByLocation(propertyData, userLocation);
//         } else {
//           setFilteredProperties([]);
//         }
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//         setError("Error loading properties");
//         setAllProperties([]);
//         setFilteredProperties([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Re-filter when user location changes
//   useEffect(() => {
//     if (allProperties.length > 0) {
//       if (userLocation) {
//         filterPropertiesByLocation(allProperties, userLocation);
//       } else {
//         setFilteredProperties([]);
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userLocation, allProperties]);

//   // Listen for location changes from localStorage
//   useEffect(() => {
//     const handleLocationChange = () => {
//       const newLocation = getUserLocation();
//       setUserLocation(newLocation);
//     };

//     window.addEventListener("storage", handleLocationChange);

//     const interval = setInterval(() => {
//       const currentLocation = getUserLocation();
//       if (currentLocation) {
//         setUserLocation(currentLocation);
//       }
//     }, 3000);

//     return () => {
//       window.removeEventListener("storage", handleLocationChange);
//       clearInterval(interval);
//     };
//   }, []);

//   // ─── Loading skeleton ─────────────────────────────────────────────────────
//   if (loading || locationLoading) {
//     return (
//       <div className="property-wrapper">
//         <div className="property-list">
//           {[1, 2, 3].map((_, index) => (
//             <div key={index} className="featured-card skeleton-card">
//               <div className="skeleton-content">
//                 <div className="skeleton-line"></div>
//                 <div className="skeleton-line short"></div>
//                 <div className="skeleton-line medium"></div>
//                 <div className="skeleton-line"></div>
//               </div>
//               <div className="skeleton-image"></div>
//             </div>
//           ))}
//         </div>
//         <style>{`
//           .property-wrapper {
//             width: 100%;
//             max-width: 470px;
//             margin: 0 auto;
//             padding: 10px;
//             background: rgb(239, 231, 221);
//           }
//           .property-list {
//             display: flex;
//             flex-direction: column;
//             gap: 10px;
//           }
//           .featured-card {
//             width: 100%;
//             height: 101px;
//             display: flex;
//             align-items: stretch;
//             overflow: hidden;
//             background: #fffaf4;
//             border: 1px solid #e5ddd4;
//             border-radius: 10px;
//             box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
//           }
//           .skeleton-card { background: #f0f0f0; }
//           .skeleton-content {
//             width: 55%;
//             padding: 12px;
//             display: flex;
//             flex-direction: column;
//             gap: 8px;
//             justify-content: center;
//           }
//           .skeleton-image {
//             width: 45%;
//             background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
//             background-size: 200% 100%;
//             animation: shimmer 1.5s infinite;
//           }
//           .skeleton-line {
//             height: 12px;
//             background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
//             background-size: 200% 100%;
//             animation: shimmer 1.5s infinite;
//             border-radius: 4px;
//             width: 80%;
//           }
//           .skeleton-line.short { width: 50%; }
//           .skeleton-line.medium { width: 65%; }
//           @keyframes shimmer {
//             0% { background-position: 200% 0; }
//             100% { background-position: -200% 0; }
//           }
//         `}</style>
//       </div>
//     );
//   }

//   // ─── No location ──────────────────────────────────────────────────────────
//   if (!userLocation) {
//     return (
//       <div className="property-wrapper">
//         <div className="no-properties-message">
//           <div className="message-content">
//             <LocationOnOutlinedIcon sx={{ fontSize: 48, color: "#8A6A3D" }} />
//             <h3>Enable Location</h3>
//             <p>Please enable location services to see properties near you.</p>
//           </div>
//         </div>
//         <style>{`
//           .property-wrapper {
//             width: 100%;
//             max-width: 470px;
//             margin: 0 auto;
//             padding: 20px 10px;
//             background: rgb(239, 231, 221);
//             min-height: 200px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }
//           .no-properties-message {
//             width: 100%;
//             text-align: center;
//             padding: 30px 20px;
//             background: white;
//             border-radius: 12px;
//             box-shadow: 0 2px 10px rgba(0,0,0,0.08);
//           }
//           .message-content {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 12px;
//           }
//           .message-content h3 { margin: 0; color: #2E2A22; font-size: 18px; }
//           .message-content p { margin: 0; color: #6B6350; font-size: 14px; max-width: 300px; }
//         `}</style>
//       </div>
//     );
//   }

//   // ─── No nearby / no matching ──────────────────────────────────────────────
//   if (filteredProperties.length === 0) {
//     return (
//       <div className="property-wrapper">
//         <div className="no-properties-message">
//           <div className="message-content">
//             <LocationOnOutlinedIcon sx={{ fontSize: 48, color: "#8A6A3D" }} />
//             <h3>No Properties Nearby</h3>
//             <p>
//               No rent description properties found within your area.
//               <br />
//               <span style={{ fontSize: "12px", color: "#8A6A3D" }}>
//                 Try expanding your search or check back later.
//               </span>
//             </p>
//             {userLocation.address && (
//               <div
//                 style={{ fontSize: "12px", color: "#6B6350", marginTop: "8px" }}
//               >
//                 📍 {userLocation.address}
//               </div>
//             )}
//           </div>
//         </div>
//         <style>{`
//           .property-wrapper {
//             width: 100%;
//             max-width: 470px;
//             margin: 0 auto;
//             padding: 20px 10px;
//             background: rgb(239, 231, 221);
//             min-height: 200px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }
//           .no-properties-message {
//             width: 100%;
//             text-align: center;
//             padding: 30px 20px;
//             background: white;
//             border-radius: 12px;
//             box-shadow: 0 2px 10px rgba(0,0,0,0.08);
//           }
//           .message-content {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 12px;
//           }
//           .message-content h3 { margin: 0; color: #2E2A22; font-size: 18px; }
//           .message-content p { margin: 0; color: #6B6350; font-size: 14px; max-width: 300px; }
//         `}</style>
//       </div>
//     );
//   }

//   // ─── Render ───────────────────────────────────────────────────────────────
//   return (
//     <div className="property-wrapper">
//       <div className="property-list">
//         {filteredProperties.map((property) => (
//           <div key={property.id} className="featured-card">
//             {/* LEFT SIDE */}
//             <div className="featured-content">
//               <div className="building-icon">
//                 <BusinessOutlinedIcon />
//               </div>

//               <div className="featured-details">
//                 <h3>{property.title}</h3>
//                 <p className="featured-subtitle">
//                   {property.category || property.subtitle}
//                 </p>
//                 <p className="featured-price">{property.price}</p>
//                 <div className="featured-location">
//                   <LocationOnOutlinedIcon />
//                   <span>{property.location}</span>
//                 </div>
//                 {property._distance !== null && (
//                   <div className="property-distance">
//                     📍 {property._distance.toFixed(1)} km away
//                     <span className="radius-info">
//                       (Radius: {property._radius} km)
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* RIGHT SIDE IMAGE */}
//             <div className="featured-image-section">
//               <span className="badge featured-badge">{property.type}</span>
//               <img
//                 src={
//                   property.image
//                     ? `${BASE_URL}${property.image}`
//                     : "https://via.placeholder.com/300x200?text=Property"
//                 }
//                 alt={property.title}
//                 onError={(e) => {
//                   e.target.src =
//                     "https://via.placeholder.com/300x200?text=Property";
//                 }}
//               />
//             </div>
//           </div>
//         ))}
//       </div>

//       <style>{`
//         * { box-sizing: border-box; }

//         .property-wrapper {
//           width: 100%;
//           max-width: 470px;
//           margin: 0 auto;
//           padding: 10px;
//           background: rgb(239, 231, 221);
//         }

//         .property-list {
//           display: flex;
//           flex-direction: column;
//           gap: 10px;
//         }

//         .featured-card {
//           width: 100%;
//           height: 101px;
//           display: flex;
//           align-items: stretch;
//           overflow: hidden;
//           background: #fffaf4;
//           border: 1px solid #e5ddd4;
//           border-radius: 10px;
//           box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
//           transition: transform 0.2s ease-in-out;
//         }

//         .featured-card:hover {
//           transform: scale(1.01);
//           box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
//         }

//         .featured-content {
//           width: 55%;
//           min-width: 0;
//           display: flex;
//           align-items: center;
//           padding: 9px 8px;
//           gap: 8px;
//         }

//         .building-icon {
//           width: 40px;
//           height: 40px;
//           min-width: 40px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border-radius: 50%;
//           background: #f8ead8;
//           flex-shrink: 0;
//         }

//         .building-icon svg {
//           font-size: 25px;
//           color: #6c4a2d;
//         }

//         .featured-details {
//           min-width: 0;
//           flex: 1;
//           overflow: hidden;
//         }

//         .featured-details h3 {
//           margin: 0;
//           color: #242424;
//           font-size: 14px;
//           font-weight: 700;
//           line-height: 17px;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-subtitle {
//           margin: 1px 0 3px;
//           color: #333;
//           font-size: 9.5px;
//           line-height: 12px;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-price {
//           margin: 0 0 3px;
//           color: #b65f13;
//           font-size: 15px;
//           font-weight: 700;
//           line-height: 17px;
//           white-space: nowrap;
//         }

//         .featured-location {
//           width: 100%;
//           display: flex;
//           align-items: center;
//           gap: 3px;
//           color: #333;
//           font-size: 9px;
//           line-height: 12px;
//           overflow: hidden;
//         }

//         .featured-location svg {
//           width: 13px;
//           height: 13px;
//           min-width: 13px;
//           color: #b66a18;
//         }

//         .featured-location span {
//           min-width: 0;
//           overflow: hidden;
//           white-space: nowrap;
//           text-overflow: ellipsis;
//         }

//         .property-distance {
//           font-size: 8px;
//           color: #8A6A3D;
//           font-weight: 600;
//           margin-top: 2px;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//         }

//         .radius-info {
//           font-weight: 400;
//           color: #6B6350;
//           font-size: 7px;
//         }

//         .featured-image-section {
//           position: relative;
//           width: 45%;
//           min-width: 0;
//           overflow: hidden;
//           flex-shrink: 0;
//         }

//         .featured-image-section img {
//           width: 100%;
//           height: 100%;
//           display: block;
//           object-fit: cover;
//           object-position: center;
//         }

//         .badge {
//           position: absolute;
//           top: 5px;
//           left: 6px;
//           z-index: 5;
//           padding: 4px 9px;
//           border-radius: 12px;
//           background: #b87829;
//           color: #fff;
//           font-size: 9px;
//           font-weight: 700;
//           line-height: 12px;
//           white-space: nowrap;
//           box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
//         }

//         @media (max-width: 380px) {
//           .property-wrapper { padding: 8px; }
//           .property-list { gap: 7px; }
//           .featured-card { height: 96px; }
//           .featured-content { width: 56%; padding: 7px 6px; gap: 6px; }
//           .featured-image-section { width: 44%; }
//           .building-icon { width: 36px; height: 36px; min-width: 36px; }
//           .building-icon svg { font-size: 22px; }
//           .featured-details h3 { font-size: 13px; }
//           .featured-subtitle { font-size: 8.5px; }
//           .featured-price { font-size: 14px; }
//           .featured-location { font-size: 8px; }
//         }

//         @media (min-width: 768px) {
//           .property-wrapper { max-width: 1200px; padding: 20px 40px; }
//           .property-list { gap: 16px; }
//           .featured-card { height: 140px; }
//           .featured-content { width: 52%; padding: 14px 18px; gap: 12px; }
//           .featured-image-section { width: 48%; }
//           .building-icon { width: 52px; height: 52px; min-width: 52px; }
//           .building-icon svg { font-size: 32px; }
//           .featured-details h3 { font-size: 18px; line-height: 22px; }
//           .featured-subtitle { font-size: 11px; line-height: 14px; }
//           .featured-price { font-size: 19px; line-height: 22px; }
//           .featured-location { font-size: 10px; }
//           .badge { top: 8px; left: 10px; padding: 5px 11px; font-size: 10px; }
//           .property-distance { font-size: 10px; }
//           .radius-info { font-size: 9px; }
//         }

//         @media (min-width: 1024px) {
//           .property-wrapper { max-width: 1400px; }
//           .featured-card { height: 160px; }
//           .featured-content { width: 45%; padding: 18px 24px; }
//           .featured-image-section { width: 55%; }
//           .featured-details h3 { font-size: 20px; line-height: 24px; }
//           .featured-price { font-size: 22px; line-height: 26px; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default RentDescriptionCard;



// // RentDescriptionCard.js
// import React, { useState, useEffect } from "react";
// import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
// import { BASE_URL } from "../../Api/ApiUrls";

// // ─── Helper: Haversine distance (km) ────────────────────────────────────────
// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const R = 6371;
//   const dLat = ((lat2 - lat1) * Math.PI) / 180;
//   const dLon = ((lon2 - lon1) * Math.PI) / 180;
//   const a =
//     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//     Math.cos((lat1 * Math.PI) / 180) *
//       Math.cos((lat2 * Math.PI) / 180) *
//       Math.sin(dLon / 2) *
//       Math.sin(dLon / 2);
//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// // ─── Helper: read user location from localStorage ───────────────────────────
// const getUserLocation = () => {
//   const lat = localStorage.getItem("userLatitude");
//   const lng = localStorage.getItem("userLongitude");
//   const address = localStorage.getItem("userLocation");

//   if (lat && lng) {
//     return {
//       latitude: parseFloat(lat),
//       longitude: parseFloat(lng),
//       address: address || "Current Location",
//     };
//   }
//   return null;
// };

// // ─── Helper: check if displaying_pannels contains "rent_description" ────────
// const matchesRentDescription = (displayingPannels) => {
//   if (!displayingPannels) return false;

//   let values = [];

//   if (Array.isArray(displayingPannels)) {
//     values = displayingPannels.map((v) =>
//       typeof v === "string" ? v : v?.name || v?.value || String(v),
//     );
//   } else if (typeof displayingPannels === "string") {
//     values = displayingPannels.split(",").map((s) => s.trim());
//   } else if (typeof displayingPannels === "object") {
//     values = Object.values(displayingPannels).map(String);
//   } else {
//     values = [String(displayingPannels)];
//   }

//   return values.some((v) => String(v).toLowerCase() === "rent_description");
// };

// // ─── Component ──────────────────────────────────────────────────────────────
// const RentDescriptionCard = () => {
//   const [allProperties, setAllProperties] = useState([]);
//   const [filteredProperties, setFilteredProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userLocation, setUserLocation] = useState(null);
//   const [locationLoading, setLocationLoading] = useState(true);

//   // Get user location on mount
//   useEffect(() => {
//     const location = getUserLocation();
//     setUserLocation(location);
//     setLocationLoading(false);
//   }, []);

//   const filterPropertiesByLocation = (properties, location) => {
//     // 🔕 Location-based filtering temporarily disabled.

//     const result = properties.map((property) => {
//       if (location && property.lat && property.long) {
//         const distance = calculateDistance(
//           location.latitude,
//           location.longitude,
//           property.lat,
//           property.long,
//         );
//         property._distance = distance;
//         property._radius = property.radius_distance || 10;
//         property._isWithinRadius = true;
//       } else {
//         property._distance = null;
//         property._radius = null;
//         property._isWithinRadius = true;
//       }
//       return property;
//     });

//     if (location) {
//       result.sort((a, b) => (a._distance || 0) - (b._distance || 0));
//     }

//     console.log(
//       `[location-filter disabled] Showing all ${result.length} properties`,
//     );
//     setFilteredProperties(result);
//   };

//   // ─── Fetch + filter by rent_description ───────────────────────────────────
//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const url = `${BASE_URL}/ad-properties/performance/?displaying_pannels=rent_description&status=true`;
//         console.log("[RentDescriptionCard] Fetching:", url);

//         const response = await fetch(url);
//         const data = await response.json();

//         let rawList = [];
//         if (Array.isArray(data)) {
//           rawList = data;
//         } else if (Array.isArray(data?.data)) {
//           rawList = data.data;
//         } else if (data?.data && typeof data.data === "object") {
//           rawList = [data.data];
//         } else if (Array.isArray(data?.results)) {
//           rawList = data.results;
//         }

//         console.log(
//           "[RentDescriptionCard] API response items:",
//           rawList.length,
//           "| sample:",
//           rawList[0],
//         );

//         const descriptionFiltered = rawList.filter((item) =>
//           matchesRentDescription(item.displaying_pannels),
//         );

//         console.log(
//           `[RentDescriptionCard] After rent_description filter:`,
//           descriptionFiltered.length,
//           "items",
//         );

//         const propertyData = descriptionFiltered.map((item) => {
//           let lat = null;
//           let long = null;
//           let radiusDistance = null;

//           if (item.lat && item.long) {
//             lat = parseFloat(item.lat);
//             long = parseFloat(item.long);
//           }
//           if (item.radius_distance) {
//             radiusDistance = parseFloat(item.radius_distance);
//           }

//           const heroImg = item.hero_images?.[0]?.image || item.image || null;

//           return {
//             id: item.property_id ?? item.id,
//             type: item.property_type || "Premium",
//             title: item.property_name || "Property",
//             subtitle: item.property_type || "Premium Apartments",
//             price: item.price
//               ? `₹${Number(item.price).toLocaleString("en-IN")}`
//               : item.max_budget
//                 ? `₹${Number(item.max_budget).toLocaleString("en-IN")}`
//                 : "₹3.25 Cr",
//             location: item.address || item.city || "Location not specified",
//             image: heroImg,
//             category: item.category_name || "",
//             tags: item.tags || "",
//             description: item.description || "",
//             lat,
//             long,
//             radius_distance: radiusDistance,
//             displaying_pannels: item.displaying_pannels,
//             _distance: null,
//             _radius: null,
//             _isWithinRadius: false,
//           };
//         });

//         setAllProperties(propertyData);

//         if (userLocation) {
//           filterPropertiesByLocation(propertyData, userLocation);
//         } else {
//           setFilteredProperties([]);
//         }
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//         setError("Error loading properties");
//         setAllProperties([]);
//         setFilteredProperties([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Re-filter when user location changes
//   useEffect(() => {
//     if (allProperties.length > 0) {
//       if (userLocation) {
//         filterPropertiesByLocation(allProperties, userLocation);
//       } else {
//         setFilteredProperties([]);
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userLocation, allProperties]);

//   // Listen for location changes from localStorage
//   useEffect(() => {
//     const handleLocationChange = () => {
//       const newLocation = getUserLocation();
//       setUserLocation(newLocation);
//     };

//     window.addEventListener("storage", handleLocationChange);

//     const interval = setInterval(() => {
//       const currentLocation = getUserLocation();
//       if (currentLocation) {
//         setUserLocation(currentLocation);
//       }
//     }, 3000);

//     return () => {
//       window.removeEventListener("storage", handleLocationChange);
//       clearInterval(interval);
//     };
//   }, []);

//   // ─── Loading skeleton ─────────────────────────────────────────────────────
//   if (loading || locationLoading) {
//     return (
//       <div className="property-wrapper">
//         <div className="property-list">
//           {[1, 2, 3].map((_, index) => (
//             <div key={index} className="featured-card skeleton-card">
//               <div className="skeleton-content">
//                 <div className="skeleton-line"></div>
//                 <div className="skeleton-line short"></div>
//                 <div className="skeleton-line medium"></div>
//                 <div className="skeleton-line"></div>
//               </div>
//               <div className="skeleton-image"></div>
//             </div>
//           ))}
//         </div>
//         <style>{`
//           .property-wrapper {
//             width: 100%;
//             max-width: 470px;
//             margin: 0 auto;
//             padding: 10px;
//             background: rgb(239, 231, 221);
//           }
//           .property-list {
//             display: flex;
//             flex-direction: column;
//             gap: 10px;
//           }
//           .featured-card {
//             width: 100%;
//             height: 101px;
//             display: flex;
//             align-items: stretch;
//             overflow: hidden;
//             background: #fffaf4;
//             border: 1px solid #e5ddd4;
//             border-radius: 10px;
//             box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
//           }
//           .skeleton-card { background: #f0f0f0; }
//           .skeleton-content {
//             width: 55%;
//             padding: 12px;
//             display: flex;
//             flex-direction: column;
//             gap: 8px;
//             justify-content: center;
//           }
//           .skeleton-image {
//             width: 45%;
//             background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
//             background-size: 200% 100%;
//             animation: shimmer 1.5s infinite;
//           }
//           .skeleton-line {
//             height: 12px;
//             background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
//             background-size: 200% 100%;
//             animation: shimmer 1.5s infinite;
//             border-radius: 4px;
//             width: 80%;
//           }
//           .skeleton-line.short { width: 50%; }
//           .skeleton-line.medium { width: 65%; }
//           @keyframes shimmer {
//             0% { background-position: 200% 0; }
//             100% { background-position: -200% 0; }
//           }
//         `}</style>
//       </div>
//     );
//   }

//   // ─── No location ──────────────────────────────────────────────────────────
//   if (!userLocation) {
//     return (
//       <div className="property-wrapper">
//         <div className="no-properties-message">
//           <div className="message-content">
//             <LocationOnOutlinedIcon sx={{ fontSize: 48, color: "#8A6A3D" }} />
//             <h3>Enable Location</h3>
//             <p>Please enable location services to see properties near you.</p>
//           </div>
//         </div>
//         <style>{`
//           .property-wrapper {
//             width: 100%;
//             max-width: 470px;
//             margin: 0 auto;
//             padding: 20px 10px;
//             background: rgb(239, 231, 221);
//             min-height: 200px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }
//           .no-properties-message {
//             width: 100%;
//             text-align: center;
//             padding: 30px 20px;
//             background: white;
//             border-radius: 12px;
//             box-shadow: 0 2px 10px rgba(0,0,0,0.08);
//           }
//           .message-content {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 12px;
//           }
//           .message-content h3 { margin: 0; color: #2E2A22; font-size: 18px; }
//           .message-content p { margin: 0; color: #6B6350; font-size: 14px; max-width: 300px; }
//         `}</style>
//       </div>
//     );
//   }

//   // ─── No nearby / no matching ──────────────────────────────────────────────
//   if (filteredProperties.length === 0) {
//     return (
//       <div className="property-wrapper">
//         <div className="no-properties-message">
//           <div className="message-content">
//             <LocationOnOutlinedIcon sx={{ fontSize: 48, color: "#8A6A3D" }} />
//             <h3>No Properties Nearby</h3>
//             <p>
//               No rent description properties found within your area.
//               <br />
//               <span style={{ fontSize: "12px", color: "#8A6A3D" }}>
//                 Try expanding your search or check back later.
//               </span>
//             </p>
//             {userLocation.address && (
//               <div
//                 style={{ fontSize: "12px", color: "#6B6350", marginTop: "8px" }}
//               >
//                 📍 {userLocation.address}
//               </div>
//             )}
//           </div>
//         </div>
//         <style>{`
//           .property-wrapper {
//             width: 100%;
//             max-width: 470px;
//             margin: 0 auto;
//             padding: 20px 10px;
//             background: rgb(239, 231, 221);
//             min-height: 200px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }
//           .no-properties-message {
//             width: 100%;
//             text-align: center;
//             padding: 30px 20px;
//             background: white;
//             border-radius: 12px;
//             box-shadow: 0 2px 10px rgba(0,0,0,0.08);
//           }
//           .message-content {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 12px;
//           }
//           .message-content h3 { margin: 0; color: #2E2A22; font-size: 18px; }
//           .message-content p { margin: 0; color: #6B6350; font-size: 14px; max-width: 300px; }
//         `}</style>
//       </div>
//     );
//   }

//   // ─── Render ───────────────────────────────────────────────────────────────
//   return (
//     <div className="property-wrapper">
//       <div className="property-list">
//         {filteredProperties.map((property) => (
//           <div key={property.id} className="featured-card">
//             {/* LEFT SIDE */}
//             <div className="featured-content">
//               <div className="building-icon">
//                 <BusinessOutlinedIcon />
//               </div>

//               <div className="featured-details">
//                 <h3>{property.title}</h3>
//                 <p className="featured-subtitle">
//                   {property.category || property.subtitle}
//                 </p>
//                 <p className="featured-price">{property.price}</p>
//                 <div className="featured-location">
//                   <LocationOnOutlinedIcon />
//                   <span>{property.location}</span>
//                 </div>
//                 {property._distance !== null && (
//                   <div className="property-distance">
//                     📍 {property._distance.toFixed(1)} km away
//                     <span className="radius-info">
//                       (Radius: {property._radius} km)
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* RIGHT SIDE IMAGE */}
//             <div className="featured-image-section">
//               <span className="badge featured-badge">{property.type}</span>
//               <img
//                 src={
//                   property.image
//                     ? `${BASE_URL}${property.image}`
//                     : "https://via.placeholder.com/300x200?text=Property"
//                 }
//                 alt={property.title}
//                 onError={(e) => {
//                   e.target.src =
//                     "https://via.placeholder.com/300x200?text=Property";
//                 }}
//               />
//             </div>
//           </div>
//         ))}
//       </div>

//       <style>{`
//         * { box-sizing: border-box; }

//         .property-wrapper {
//           width: 100%;
//           max-width: 470px;
//           margin: 0 auto;
//           padding: 10px;
//           background: rgb(239, 231, 221);
//         }

//         .property-list {
//           display: flex;
//           flex-direction: column;
//           gap: 10px;
//         }

//         .featured-card {
//           width: 100%;
//           height: 101px;
//           display: flex;
//           align-items: stretch;
//           overflow: hidden;
//           background: #fffaf4;
//           border: 1px solid #e5ddd4;
//           border-radius: 10px;
//           box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
//           transition: transform 0.2s ease-in-out;
//         }

//         .featured-card:hover {
//           transform: scale(1.01);
//           box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
//         }

//         .featured-content {
//           width: 55%;
//           min-width: 0;
//           display: flex;
//           align-items: center;
//           padding: 9px 8px;
//           gap: 8px;
//         }

//         .building-icon {
//           width: 40px;
//           height: 40px;
//           min-width: 40px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border-radius: 50%;
//           background: #f8ead8;
//           flex-shrink: 0;
//         }

//         .building-icon svg {
//           font-size: 25px;
//           color: #6c4a2d;
//         }

//         .featured-details {
//           min-width: 0;
//           flex: 1;
//           overflow: hidden;
//         }

//         .featured-details h3 {
//           margin: 0;
//           color: #242424;
//           font-size: 14px;
//           font-weight: 700;
//           line-height: 17px;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-subtitle {
//           margin: 1px 0 3px;
//           color: #333;
//           font-size: 9.5px;
//           line-height: 12px;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-price {
//           margin: 0 0 3px;
//           color: #b65f13;
//           font-size: 15px;
//           font-weight: 700;
//           line-height: 17px;
//           white-space: nowrap;
//         }

//         .featured-location {
//           width: 100%;
//           display: flex;
//           align-items: center;
//           gap: 3px;
//           color: #333;
//           font-size: 9px;
//           line-height: 12px;
//           overflow: hidden;
//         }

//         .featured-location svg {
//           width: 13px;
//           height: 13px;
//           min-width: 13px;
//           color: #b66a18;
//         }

//         .featured-location span {
//           min-width: 0;
//           overflow: hidden;
//           white-space: nowrap;
//           text-overflow: ellipsis;
//         }

//         .property-distance {
//           font-size: 8px;
//           color: #8A6A3D;
//           font-weight: 600;
//           margin-top: 2px;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//         }

//         .radius-info {
//           font-weight: 400;
//           color: #6B6350;
//           font-size: 7px;
//         }

//         .featured-image-section {
//           position: relative;
//           width: 45%;
//           min-width: 0;
//           overflow: hidden;
//           flex-shrink: 0;
//         }

//         .featured-image-section img {
//           width: 100%;
//           height: 100%;
//           display: block;
//           object-fit: cover;
//           object-position: center;
//         }

//         .badge {
//           position: absolute;
//           top: 5px;
//           left: 6px;
//           z-index: 5;
//           padding: 4px 9px;
//           border-radius: 12px;
//           background: #b87829;
//           color: #fff;
//           font-size: 9px;
//           font-weight: 700;
//           line-height: 12px;
//           white-space: nowrap;
//           box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
//         }

//         @media (max-width: 380px) {
//           .property-wrapper { padding: 8px; }
//           .property-list { gap: 7px; }
//           .featured-card { height: 96px; }
//           .featured-content { width: 56%; padding: 7px 6px; gap: 6px; }
//           .featured-image-section { width: 44%; }
//           .building-icon { width: 36px; height: 36px; min-width: 36px; }
//           .building-icon svg { font-size: 22px; }
//           .featured-details h3 { font-size: 13px; }
//           .featured-subtitle { font-size: 8.5px; }
//           .featured-price { font-size: 14px; }
//           .featured-location { font-size: 8px; }
//         }

//         @media (min-width: 768px) {
//           .property-wrapper { max-width: 1200px; padding: 20px 40px; }
//           .property-list { gap: 16px; }
//           .featured-card { height: 140px; }
//           .featured-content { width: 52%; padding: 14px 18px; gap: 12px; }
//           .featured-image-section { width: 48%; }
//           .building-icon { width: 52px; height: 52px; min-width: 52px; }
//           .building-icon svg { font-size: 32px; }
//           .featured-details h3 { font-size: 18px; line-height: 22px; }
//           .featured-subtitle { font-size: 11px; line-height: 14px; }
//           .featured-price { font-size: 19px; line-height: 22px; }
//           .featured-location { font-size: 10px; }
//           .badge { top: 8px; left: 10px; padding: 5px 11px; font-size: 10px; }
//           .property-distance { font-size: 10px; }
//           .radius-info { font-size: 9px; }
//         }

//         @media (min-width: 1024px) {
//           .property-wrapper { max-width: 1400px; }
//           .featured-card { height: 160px; }
//           .featured-content { width: 45%; padding: 18px 24px; }
//           .featured-image-section { width: 55%; }
//           .featured-details h3 { font-size: 20px; line-height: 24px; }
//           .featured-price { font-size: 22px; line-height: 26px; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default RentDescriptionCard;



import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import { BASE_URL } from "../../Api/ApiUrls";

// Max cards to display
const MAX_DISPLAY_COUNT = 3;

// ─── Helper: Haversine distance (km) ────────────────────────────────────────
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

// ─── Helper: read user location from localStorage ───────────────────────────
const getUserLocation = () => {
  const lat = localStorage.getItem("userLatitude");
  const lng = localStorage.getItem("userLongitude");
  const address = localStorage.getItem("userLocation");

  if (lat && lng) {
    return {
      latitude: parseFloat(lat),
      longitude: parseFloat(lng),
      address: address || "Current Location",
    };
  }
  return null;
};

// ─── Helper: check if displaying_pannels contains "rent_description" ────────
const matchesRentDescription = (displayingPannels) => {
  if (!displayingPannels) return false;

  let values = [];

  if (Array.isArray(displayingPannels)) {
    values = displayingPannels.map((v) =>
      typeof v === "string" ? v : v?.name || v?.value || String(v),
    );
  } else if (typeof displayingPannels === "string") {
    values = displayingPannels.split(",").map((s) => s.trim());
  } else if (typeof displayingPannels === "object") {
    values = Object.values(displayingPannels).map(String);
  } else {
    values = [String(displayingPannels)];
  }

  return values.some((v) => String(v).toLowerCase() === "rent_description");
};

// ─── Component ──────────────────────────────────────────────────────────────
const RentDescriptionCard = () => {
  const navigate = useNavigate();

  const [allProperties, setAllProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const [locationLoading, setLocationLoading] = useState(true);

  // Get user location on mount
  useEffect(() => {
    const location = getUserLocation();
    setUserLocation(location);
    setLocationLoading(false);
  }, []);

  // ─── Location-based filtering (radius check ENABLED) ─────────────────────
  const filterPropertiesByLocation = (properties, location) => {
    if (!location) {
      setFilteredProperties([]);
      return;
    }

    const filtered = properties.filter((property) => {
      // Skip properties without coordinates
      if (!property.lat || !property.long) return false;

      const distance = calculateDistance(
        location.latitude,
        location.longitude,
        property.lat,
        property.long,
      );

      const radiusDistance = property.radius_distance || 10;
      const isWithinRadius = distance <= radiusDistance;

      property._distance = distance;
      property._radius = radiusDistance;
      property._isWithinRadius = isWithinRadius;

      return isWithinRadius;
    });

    // Sort by nearest first
    filtered.sort((a, b) => (a._distance || 0) - (b._distance || 0));

    // ✅ Limit to only 3 properties
    const limited = filtered.slice(0, MAX_DISPLAY_COUNT);

    console.log(
      `[RentDescriptionCard] Nearby: ${filtered.length} | Showing: ${limited.length} (max ${MAX_DISPLAY_COUNT})`,
    );

    setFilteredProperties(limited);
  };

  // ─── Fetch + filter by rent_description ───────────────────────────────────
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        setError(null);

        const url = `${BASE_URL}/ad-properties/performance/?displaying_pannels=rent_description&status=true`;
        console.log("[RentDescriptionCard] Fetching:", url);

        const response = await fetch(url);
        const data = await response.json();

        let rawList = [];
        if (Array.isArray(data)) {
          rawList = data;
        } else if (Array.isArray(data?.data)) {
          rawList = data.data;
        } else if (data?.data && typeof data.data === "object") {
          rawList = [data.data];
        } else if (Array.isArray(data?.results)) {
          rawList = data.results;
        }

        console.log(
          "[RentDescriptionCard] API response items:",
          rawList.length,
          "| sample:",
          rawList[0],
        );

        const descriptionFiltered = rawList.filter((item) =>
          matchesRentDescription(item.displaying_pannels),
        );

        console.log(
          `[RentDescriptionCard] After rent_description filter:`,
          descriptionFiltered.length,
          "items",
        );

        const propertyData = descriptionFiltered.map((item) => {
          let lat = null;
          let long = null;
          let radiusDistance = null;

          if (item.lat && item.long) {
            lat = parseFloat(item.lat);
            long = parseFloat(item.long);
          }
          if (item.radius_distance) {
            radiusDistance = parseFloat(item.radius_distance);
          }

          const heroImg = item.hero_images?.[0]?.image || item.image || null;

          return {
            id: item.property_id ?? item.id,
            type: item.property_type || "Premium",
            title: item.property_name || "Property",
            subtitle: item.property_type || "Premium Apartments",
            price: item.price
              ? `₹${Number(item.price).toLocaleString("en-IN")}`
              : item.max_budget
                ? `₹${Number(item.max_budget).toLocaleString("en-IN")}`
                : "₹3.25 Cr",
            location: item.address || item.city || "Location not specified",
            image: heroImg,
            category: item.category_name || "",
            tags: item.tags || "",
            description: item.description || "",
            lat,
            long,
            radius_distance: radiusDistance,
            displaying_pannels: item.displaying_pannels,
            _distance: null,
            _radius: null,
            _isWithinRadius: false,
          };
        });

        setAllProperties(propertyData);

        if (userLocation) {
          filterPropertiesByLocation(propertyData, userLocation);
        } else {
          setFilteredProperties([]);
        }
      } catch (err) {
        console.error("Error fetching properties:", err);
        setError("Error loading properties");
        setAllProperties([]);
        setFilteredProperties([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Re-filter when user location changes
  useEffect(() => {
    if (allProperties.length > 0) {
      if (userLocation) {
        filterPropertiesByLocation(allProperties, userLocation);
      } else {
        setFilteredProperties([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLocation, allProperties]);

  // Listen for location changes from localStorage
  useEffect(() => {
    const handleLocationChange = () => {
      const newLocation = getUserLocation();
      setUserLocation(newLocation);
    };

    window.addEventListener("storage", handleLocationChange);

    const interval = setInterval(() => {
      const currentLocation = getUserLocation();
      if (currentLocation) {
        setUserLocation(currentLocation);
      }
    }, 3000);

    return () => {
      window.removeEventListener("storage", handleLocationChange);
      clearInterval(interval);
    };
  }, []);

  // ─── Loading skeleton ─────────────────────────────────────────────────────
  if (loading || locationLoading) {
    return (
      <div className="property-wrapper">
        <div className="property-list">
          {[1, 2, 3].map((_, index) => (
            <div key={index} className="featured-card skeleton-card">
              <div className="skeleton-content">
                <div className="skeleton-line"></div>
                <div className="skeleton-line short"></div>
                <div className="skeleton-line medium"></div>
                <div className="skeleton-line"></div>
              </div>
              <div className="skeleton-image"></div>
            </div>
          ))}
        </div>
        <style>{`
          .property-wrapper {
            width: 100%;
            max-width: 470px;
            margin: 0 auto;
            padding: 10px;
            background: rgb(239, 231, 221);
          }
          .property-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .featured-card {
            width: 100%;
            height: 130px;
            display: flex;
            align-items: stretch;
            overflow: hidden;
            background: #fffaf4;
            border: 1px solid #e5ddd4;
            border-radius: 10px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
          }
          .skeleton-card { background: #f0f0f0; }
          .skeleton-content {
            width: 55%;
            padding: 12px;
            display: flex;
            flex-direction: column;
            gap: 8px;
            justify-content: center;
          }
          .skeleton-image {
            width: 45%;
            background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
            background-size: 200% 100%;
            animation: shimmer 1.5s infinite;
          }
          .skeleton-line {
            height: 12px;
            background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
            background-size: 200% 100%;
            animation: shimmer 1.5s infinite;
            border-radius: 4px;
            width: 80%;
          }
          .skeleton-line.short { width: 50%; }
          .skeleton-line.medium { width: 65%; }
          @keyframes shimmer {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `}</style>
      </div>
    );
  }

  // ─── No location → prompt user ────────────────────────────────────────────
  // if (!userLocation) {
  //   return (
  //     <div className="property-wrapper">
  //       <div className="no-properties-message">
  //         <div className="message-content">
  //           <LocationOnOutlinedIcon sx={{ fontSize: 48, color: "#8A6A3D" }} />
  //           <h3>Enable Location</h3>
  //           <p>Please enable location services to see properties near you.</p>
  //         </div>
  //       </div>
  //       <style>{`
  //         .property-wrapper {
  //           width: 100%;
  //           max-width: 470px;
  //           margin: 0 auto;
  //           padding: 20px 10px;
  //           background: rgb(239, 231, 221);
  //           min-height: 200px;
  //           display: flex;
  //           align-items: center;
  //           justify-content: center;
  //         }
  //         .no-properties-message {
  //           width: 100%;
  //           text-align: center;
  //           padding: 30px 20px;
  //           background: white;
  //           border-radius: 12px;
  //           box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  //         }
  //         .message-content {
  //           display: flex;
  //           flex-direction: column;
  //           align-items: center;
  //           gap: 12px;
  //         }
  //         .message-content h3 { margin: 0; color: #2E2A22; font-size: 18px; }
  //         .message-content p { margin: 0; color: #6B6350; font-size: 14px; max-width: 300px; }
  //       `}</style>
  //     </div>
  //   );
  // }

  // ─── No nearby / no matching ──────────────────────────────────────────────
  // if (filteredProperties.length === 0) {
  //   return (
  //     <div className="property-wrapper">
  //       <div className="no-properties-message">
  //         <div className="message-content">
  //           <LocationOnOutlinedIcon sx={{ fontSize: 48, color: "#8A6A3D" }} />
  //           <h3>No Properties Nearby</h3>
  //           <p>
  //             No rent description properties found within your area.
  //             <br />
  //             <span style={{ fontSize: "12px", color: "#8A6A3D" }}>
  //               Try expanding your search or check back later.
  //             </span>
  //           </p>
  //           {userLocation.address && (
  //             <div
  //               style={{ fontSize: "12px", color: "#6B6350", marginTop: "8px" }}
  //             >
  //               📍 {userLocation.address}
  //             </div>
  //           )}
  //         </div>
  //       </div>
  //       <style>{`
  //         .property-wrapper {
  //           width: 100%;
  //           max-width: 470px;
  //           margin: 0 auto;
  //           padding: 20px 10px;
  //           background: rgb(239, 231, 221);
  //           min-height: 200px;
  //           display: flex;
  //           align-items: center;
  //           justify-content: center;
  //         }
  //         .no-properties-message {
  //           width: 100%;
  //           text-align: center;
  //           padding: 30px 20px;
  //           background: white;
  //           border-radius: 12px;
  //           box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  //         }
  //         .message-content {
  //           display: flex;
  //           flex-direction: column;
  //           align-items: center;
  //           gap: 12px;
  //         }
  //         .message-content h3 { margin: 0; color: #2E2A22; font-size: 18px; }
  //         .message-content p { margin: 0; color: #6B6350; font-size: 14px; max-width: 300px; }
  //       `}</style>
  //     </div>
  //   );
  // }

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div className="property-wrapper">
      <div className="property-list">
        {filteredProperties.map((property) => (
          <div
            key={property.id}
            className="featured-card"
            onClick={() => navigate(`/addspageindetail/${property.id}`)}
            style={{ cursor: "pointer" }}
          >
            {/* LEFT SIDE */}
            <div className="featured-content">
              <div className="building-icon">
                <BusinessOutlinedIcon />
              </div>

              <div className="featured-details">
                <h3>{property.title}</h3>
                <p className="featured-subtitle">
                  {property.category || property.subtitle}
                </p>
                <p className="featured-price">{property.price}</p>
                <div className="featured-location">
                  <LocationOnOutlinedIcon />
                  <span>{property.location}</span>
                </div>
                {property._distance !== null && (
                  <div className="property-distance">
                    📍 {property._distance.toFixed(1)} km away
                    <span className="radius-info">
                      (Radius: {property._radius} km)
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* RIGHT SIDE IMAGE */}
            <div className="featured-image-section">
              <span className="badge featured-badge">{property.type}</span>
              <img
                src={
                  property.image
                    ? `${BASE_URL}${property.image}`
                    : "https://via.placeholder.com/300x200?text=Property"
                }
                alt={property.title}
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/300x200?text=Property";
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <style>{`
        * { box-sizing: border-box; }

        .property-wrapper {
          width: 100%;
          max-width: 470px;
          margin: 0 auto;
          padding: 10px;
          background: rgb(239, 231, 221);
        }

        .property-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .featured-card {
          width: 100%;
          height: 160px;
          display: flex;
          align-items: stretch;
          overflow: hidden;
          background: #fffaf4;
          border: 1px solid #e5ddd4;
          border-radius: 10px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
          transition: transform 0.2s ease-in-out;
        }

        .featured-card:hover {
          transform: scale(1.01);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
        }

        .featured-content {
          width: 55%;
          min-width: 0;
          display: flex;
          align-items: center;
          padding: 12px 10px;
          gap: 9px;
        }

        .building-icon {
          width: 46px;
          height: 46px;
          min-width: 46px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #f8ead8;
          flex-shrink: 0;
        }

        .building-icon svg {
          font-size: 28px;
          color: #6c4a2d;
        }

        .featured-details {
          min-width: 0;
          flex: 1;
          overflow: hidden;
        }

        .featured-details h3 {
          margin: 0;
          color: #242424;
          font-size: 15px;
          font-weight: 700;
          line-height: 19px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .featured-subtitle {
          margin: 2px 0 4px;
          color: #333;
          font-size: 10.5px;
          line-height: 13px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .featured-price {
          margin: 0 0 4px;
          color: #b65f13;
          font-size: 17px;
          font-weight: 700;
          line-height: 19px;
          white-space: nowrap;
        }

        .featured-location {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 3px;
          color: #333;
          font-size: 10px;
          line-height: 13px;
          overflow: hidden;
        }

        .featured-location svg {
          width: 14px;
          height: 14px;
          min-width: 14px;
          color: #b66a18;
        }

        .featured-location span {
          min-width: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .property-distance {
          font-size: 9px;
          color: #8A6A3D;
          font-weight: 600;
          margin-top: 3px;
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .radius-info {
          font-weight: 400;
          color: #6B6350;
          font-size: 8px;
        }

        .featured-image-section {
          position: relative;
          width: 45%;
          min-width: 0;
          overflow: hidden;
          flex-shrink: 0;
        }

        .featured-image-section img {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
          object-position: center;
        }

        .badge {
          position: absolute;
          top: 6px;
          left: 7px;
          z-index: 5;
          padding: 4px 9px;
          border-radius: 12px;
          background: #b87829;
          color: #fff;
          font-size: 9px;
          font-weight: 700;
          line-height: 12px;
          white-space: nowrap;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
        }

        @media (max-width: 380px) {
          .property-wrapper { padding: 8px; }
          .property-list { gap: 7px; }
          .featured-card { height: 122px; }
          .featured-content { width: 56%; padding: 10px 8px; gap: 7px; }
          .featured-image-section { width: 44%; }
          .building-icon { width: 42px; height: 42px; min-width: 42px; }
          .building-icon svg { font-size: 25px; }
          .featured-details h3 { font-size: 14px; }
          .featured-subtitle { font-size: 9.5px; }
          .featured-price { font-size: 16px; }
          .featured-location { font-size: 9px; }
        }

        @media (min-width: 768px) {
          .property-wrapper { max-width: 1200px; padding: 20px 40px; }
          .property-list { gap: 16px; }
          .featured-card { height: 165px; }
          .featured-content { width: 52%; padding: 16px 20px; gap: 13px; }
          .featured-image-section { width: 48%; }
          .building-icon { width: 58px; height: 58px; min-width: 58px; }
          .building-icon svg { font-size: 36px; }
          .featured-details h3 { font-size: 20px; line-height: 24px; }
          .featured-subtitle { font-size: 12px; line-height: 15px; }
          .featured-price { font-size: 22px; line-height: 26px; }
          .featured-location { font-size: 11px; }
          .badge { top: 9px; left: 11px; padding: 5px 12px; font-size: 11px; }
          .property-distance { font-size: 11px; }
          .radius-info { font-size: 10px; }
        }

        @media (min-width: 1024px) {
          .property-wrapper { max-width: 1400px; }
          .featured-card { height: 185px; }
          .featured-content { width: 45%; padding: 20px 26px; }
          .featured-image-section { width: 55%; }
          .featured-details h3 { font-size: 22px; line-height: 26px; }
          .featured-price { font-size: 25px; line-height: 29px; }
        }
      `}</style>
    </div>
  );
};

export default RentDescriptionCard;